import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import WhatsAppFloat from "./WhatsAppFloat";

const META = {
  "/": {
    title: "Managed Cloud Backup for Indian Businesses | VaultSafe",
    description:
      "VaultSafe is managed cloud backup for Indian businesses. We install it, it backs up daily by itself, and we restore your files when you need them. From ₹199/PC/month.",
  },
  "/pricing": {
    title: "VaultSafe Pricing — Cloud Backup Plans from ₹199/month",
    description:
      "Simple per-computer pricing for Indian businesses. 25 GB to 500 GB storage. Billed annually, no hidden fees.",
  },
  "/how-it-works": {
    title: "How VaultSafe Works — Managed Cloud Backup",
    description:
      "We install it, it backs up daily by itself, we restore your files when you need them.",
  },
  "/faq": {
    title: "VaultSafe FAQ — Cloud Backup Questions Answered",
    description:
      "Is it safe? Will it slow my PC? What about ransomware? Answers to the questions Indian businesses ask us most.",
  },
  "/contact": {
    title: "Contact VaultSafe — Managed Cloud Backup",
    description: "Talk to us on WhatsApp or call. Same-day response.",
  },
  "/get-started": {
    title: "Get Started — VaultSafe Managed Cloud Backup",
    description: "Pick a plan and tell us about your business. We reply within one business day.",
  },
  "/privacy": {
    title: "Privacy Policy | VaultSafe",
    description: "How VaultSafe handles your personal and business data.",
  },
  "/terms": {
    title: "Terms & Conditions | VaultSafe",
    description: "The terms under which VaultSafe provides its backup service.",
  },
  "/refund-policy": {
    title: "Refund & Cancellation Policy | VaultSafe",
    description: "How refunds and cancellations work at VaultSafe.",
  },
  "/service-delivery": {
    title: "Service Delivery Policy | VaultSafe",
    description: "How VaultSafe delivers its digital backup service.",
  },
};

export default function Layout() {
  const { pathname } = useLocation();

  useEffect(() => {
    const meta = META[pathname] || META["/"];
    document.title = meta.title;
    let desc = document.querySelector('meta[name="description"]');
    if (!desc) {
      desc = document.createElement("meta");
      desc.setAttribute("name", "description");
      document.head.appendChild(desc);
    }
    desc.setAttribute("content", meta.description);
    window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
  }, [pathname]);

  return (
    <div className="min-h-screen flex flex-col bg-white font-sans">
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}
